import Swiper from "swiper";
import "swiper/css";

export default () => ({
	init() {
		const swiper = new Swiper(
			this.$root.querySelector(".timeline-swiper"),
			{
				slidesPerView: 1,
				spaceBetween: 0,
				breakpoints: {
					640: {
						slidesPerView: 2,
						spaceBetween: 50,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 150,
					},
				},
				on: {
					afterInit: (swiper) => this.setEventHeight(),
				},
			}
		);
		window.addEventListener("resize", () => this.setEventHeight());
	},
	setEventHeight() {
		let events = this.$root.querySelectorAll(".event");
		events.forEach((event) => {
			event.style.height = "auto";
		});
		let maxHeight = Math.max(
			...Array.from(events).map((event) => event.offsetHeight)
		);
		events.forEach((event) => {
			event.style.height = maxHeight + "px";
		});
	},
});
